import { toString } from 'lodash';
import url from 'url';

import { ACTION_PREFIX, CARRIER } from '../constants';
import { INSURANCE_TYPES } from '@zocdoc-frontend-common/utils-react';
import bcbsCarriersSelector from './bcbsCarriersSelector';

export const REQUEST_BCBS_CARRIERS = `${ACTION_PREFIX}/REQUEST_BCBS_CARRIERS`;
export const REQUEST_BCBS_CARRIERS_SUCCEEDED = `${ACTION_PREFIX}/REQUEST_BCBS_CARRIERS_SUCCEEDED`;
export const REQUEST_BCBS_CARRIERS_FAILED = `${ACTION_PREFIX}/REQUEST_BCBS_CARRIERS_FAILED`;

const apiUrl = url.parse(process.env.API_HOST || '');

function requestBcbsCarriers() {
    return {
        type: REQUEST_BCBS_CARRIERS,
    };
}

function requestBcbsCarriersSucceeded(carriers) {
    return {
        type: REQUEST_BCBS_CARRIERS_SUCCEEDED,
        payload: {
            carriers: carriers.map(([carrierId, ...rest]) => [
                toString(carrierId),
                ...rest,
            ]),
        },
    };
}

function requestBcbsCarriersFailed() {
    return {
        type: REQUEST_BCBS_CARRIERS_FAILED,
    };
}

function fetchBcbsCarriers() {
    return dispatch => {
        dispatch(requestBcbsCarriers());

        return fetch(
            url.format({
                protocol: apiUrl.protocol,
                host: apiUrl.host,
                pathname: '/api/1/carriers',
                query: {
                    parent: CARRIER.BLUE_CROSS_BLUE_SHIELD,
                    type: INSURANCE_TYPES.HEALTH,
                },
            }),
            {
                credentials: 'same-origin',
            }
        )
            .then(response => response.json())
            .then(json => dispatch(requestBcbsCarriersSucceeded(json.carriers)))
            .catch(() => dispatch(requestBcbsCarriersFailed()));
    };
}

function shouldFetchBcbsCarriers(state) {
    const bcbsCarriers = bcbsCarriersSelector(state);
    if (bcbsCarriers.length === 0) {
        return true;
    }
    return false;
}

export function fetchBcbsCarriersIfNeeded() {
    return (dispatch, getState) => {
        const state = getState();
        if (shouldFetchBcbsCarriers(state)) {
            return dispatch(fetchBcbsCarriers());
        }
    };
}
